import {
  DASHBOARD_DATAS_DOWNLOADED,
  DASHBOARD_DATAS_FAILED,
  DASHBOARD_DATAS_PENDING,
  DASHBOARD_DATAS_RESET, DASHBOARD_LATE_RENTS_DOWNLOADED,
} from './types';
import { handleError } from '../infos/actions';
import DashboardApiService from '../../services/api/DashboardApiService';

export const dashboardDatasResetAction = () => ({
  type: DASHBOARD_DATAS_RESET,
});
export const dashboardDatasPendingAction = () => ({
  type: DASHBOARD_DATAS_PENDING,
});

export const dashboardDatasDownloadedAction = (dashboardDatas) => ({
  type: DASHBOARD_DATAS_DOWNLOADED,
  payload: dashboardDatas,
});

export const dashboardLateRentsDownloadAction = (lateRents) => ({
  type: DASHBOARD_LATE_RENTS_DOWNLOADED,
  payload: lateRents,
});

export const dashboardDatasFailedAction = (error) => ({
  type: DASHBOARD_DATAS_FAILED,
  payload: error,
});

// Actions

export function resetDashboardDatas() {
  return (dispatch) => {
    dispatch(dashboardDatasResetAction());
  };
}

export function getDashboardDatas(authUserToken, role) {
  return (dispatch) => {
    dispatch(dashboardDatasPendingAction());
    return DashboardApiService
      .getDashboard(authUserToken, role)
      .then((data) => {
        dispatch(dashboardDatasDownloadedAction(data));
      })
      .catch((error) => {
        dispatch(dashboardDatasFailedAction(error));
        dispatch(handleError(error));
      });
  };
}

export function getLateRents(authUserToken, role) {
  return (dispatch) => {
    dispatch(dashboardDatasPendingAction());
    return DashboardApiService
      .getLateRents(authUserToken, role)
      .then((data) => {
        dispatch(dashboardLateRentsDownloadAction(data));
      })
      .catch((error) => {
        dispatch(dashboardDatasFailedAction(error));
        dispatch(handleError(error));
      });
  };
}



// WEBPACK FOOTER //
// ./src/store/dashboardDatas/actions.js